import { search, sortKind } from 'fast-fuzzy';
import type { Cues } from '@studio/types';

const filterCuesBySearch = (
  cues?: Readonly<Cues.Derived.CueWithUser[]>,
  searchTerm = ''
): Readonly<Cues.Derived.CueWithUser[]> | undefined => {
  if (!searchTerm || !cues) {
    return cues;
  }

  return search(searchTerm, [...cues], {
    keySelector: ({ name, user }) => [name, user],
    sortBy: sortKind.insertOrder,
  });
};

export default filterCuesBySearch;
